<template>
  <div id="web-account-direct">
    <div class="heading">
      <h1>{{ txcc.heading }}</h1>
    </div>
    <div class="information">
      {{ txcc.information }}
    </div>
    <section>
      <button
        class="secondary-hit fluid login-button"
        @click="requestForWebAccountCreate()"
      >
        {{ txcc.buttonText }}
      </button>
    </section>
  </div>
</template>

<script>
import customTranslations from "../translations";

export default {
  name: "WebAccountDirect",
  data() {
    return {
      txcc: customTranslations[this.language],
    };
  },
  props: {
    language: {
      type: String,
      default: "en",
    },
    marketlang: {
      type: String,
      default: "en",
    },
    market: {
      type: String,
      default: "US",
    },
  },
  computed: {},
  mounted: function () {
    const self = this;
    if (
      typeof window.loginPageConfig.market != "undefined" &&
      window.loginPageConfig.market
    ) {
      self.market = window.loginPageConfig.market;
    }
    if (
      typeof window.loginPageConfig.language != "undefined" &&
      window.loginPageConfig.language
    ) {
      self.language = window.loginPageConfig.language;
      self.marketlang = window.loginPageConfig.language;
    }
  },
  methods: {
    requestForWebAccountCreate() {
      let baseContext = "/content/nuskin/";
      if (this.marketlang == "ja") {
        baseContext = "/content/markets/";
      }
      let locale = this.marketlang + "_" + this.market;
      window.location =
        baseContext +
        locale +
        "/sign-up/web-account-create.html#/web-account-create";
    },
  },
};
</script>

<style lang="scss">
#web-account-direct {
  width: 500px;
  margin: 0 auto;
  .heading,
  .information {
    padding-bottom: 30px;
  }
}
</style>
